"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var getPlacementFromAdUnitId_1 = __importDefault(require("../utils/getPlacementFromAdUnitId"));
var getPlacementDetails_1 = require("../utils/getPlacementDetails");
var getAdsenseAdString_1 = __importDefault(require("../utils/getAdsenseAdString"));
var loadAFPAd = function (adPlacementId, clientId) {
    var _a;
    var adContainer = document.getElementById(adPlacementId);
    if (adContainer) {
        var adMarkup = (0, getAdsenseAdString_1.default)(adPlacementId, clientId, window.wattpad.afpConfig.hostAccountId);
        adContainer.innerHTML = adMarkup;
    }
    else if (window.wattpad.afpConfig && !window.app.currentView) {
        console.warn("adContainer not found, unable to inject AFP ad: " + adPlacementId);
    }
    // Options for the observer (which mutations to observe)
    var config = { attributes: true, childList: false, subtree: false };
    // Callback function to execute when mutations are observed
    var callback = function (mutationList, mObserver) {
        for (var _i = 0, mutationList_1 = mutationList; _i < mutationList_1.length; _i++) {
            var mutation = mutationList_1[_i];
            var element = mutation.target;
            if (mutation.type === "attributes" &&
                mutation.attributeName === "data-ad-status") {
                var value = element.getAttribute(mutation.attributeName);
                if (value === "unfilled") {
                    window.__atha.sendAuctionResult(adPlacementId, undefined, []);
                }
                else if (value === "filled") {
                    window.__atha.sendImpression(adPlacementId, "n/a", "afp", 0, "");
                }
                else {
                    console.warn("".concat(adPlacementId, ": The ").concat(mutation.attributeName, " attribute was modified from ").concat(mutation.oldValue, " to ").concat(value));
                }
                // once we've sent an event, disconnect
                mObserver.disconnect();
            }
        }
    };
    // Create an observer instance linked to the callback function
    var observer = new MutationObserver(callback);
    // there are is a div with sizes, then the ins tag in AFP markup, and we want to
    // attach the mutation observer to the ins tag
    if ((_a = adContainer === null || adContainer === void 0 ? void 0 : adContainer.firstChild) === null || _a === void 0 ? void 0 : _a.firstChild) {
        observer.observe(adContainer.firstChild.firstChild, config);
    }
    if (!window.adsbygoogle) {
        window.adsbygoogle = [];
    }
    window.adsbygoogle.push({});
    var id = window.__atha.sendRequest(adPlacementId, "afp", (0, getPlacementDetails_1.getPlacementDetails)((0, getPlacementFromAdUnitId_1.default)(adPlacementId)));
};
exports.default = loadAFPAd;
